import { createFileRoute, useRouter } from "@tanstack/react-router";
import HelpCircle from "@repo/icons/default/HelpCircle";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import { z } from "zod";
import {
  HeaderRoot,
  HeaderButton,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { OneLivBasicInfoForm } from "@/components/oneliv/oneliv-basic-info-form";
import { OneLivHelperDrawer } from "@/components/oneliv/oneliv-helper-drawer";

import type { JSX } from "react";

const GetOneLivUserBasicInfo = graphql(`
  query GetOneLivUserBasicInfo {
    ...OneLivBasicInfoFormFragment
  }
`);

const oneLivBasicInfoPageSearchSchema = z.object({
  action: z.string().optional().catch(""),
});

const OneLivBasicInfo = (): JSX.Element => {
  const query = useGraphQL(GetOneLivUserBasicInfo);

  const { data } = query;

  const router = useRouter();

  const onBackButtonClick = (): void => {
    router.history.back();
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton onClick={onBackButtonClick} icon={Left} align="start" />
        <HeaderTitle title="Perfil OneLiv" align="center" />
        <HeaderButton
          align="end"
          icon={HelpCircle}
          onClick={() =>
            void router.navigate({
              to: ".",
              search: { action: "help" },
            })
          }
        />
      </HeaderRoot>

      <Page>
        <AsyncDataWrapper {...query}>
          {data ? <OneLivBasicInfoForm data={data} /> : null}
          <OneLivHelperDrawer />
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/oneliv/basic-info")({
  component: OneLivBasicInfo,
  validateSearch: oneLivBasicInfoPageSearchSchema,
});
